(function() {
    'use strict';

    window.addEventListener('load', function() {
        if (typeof Swiper === 'undefined') {
            return;
        }

        var productGalleries = document.querySelectorAll('.b-hero-product__gallery');

        if (productGalleries.length === 0) {
            return;
        }

        productGalleries.forEach(function(productGallery) {
            var mainElement = productGallery.querySelector('.b-hero-product__main');
            var thumbsElement = productGallery.querySelector('.b-hero-product__thumbs');
            var nextButton = productGallery.querySelector('.swiper-button-next');
            var prevButton = productGallery.querySelector('.swiper-button-prev');

            if (!mainElement || !thumbsElement) {
                return;
            }

            var thumbsSwiper = new Swiper(thumbsElement, {
                direction: 'vertical',
                spaceBetween: 8,
                slidesPerView: 4,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                freeMode: true
            });

            new Swiper(mainElement, {
                spaceBetween: 12,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton
                },
                thumbs: {
                    swiper: thumbsSwiper
                }
            });
        });
    });
    
})();